import { useMemo } from "react";
import { useRouter } from "next/router";
import NoContentMessage from "@/components/NoContentMessage";
import PaletteMetaTags from "@/components/MetaTags/PaletteMetaTags";
import { usePaletteQuery } from "@/hooks";
import { GRID_PAGE_LIMIT } from "@/lib/constants";
import PaletteGrid from "@/components/PaletteGrid";
import styles from "@/styles/PalettePage.module.scss";
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var __N_SSP = true;
export default function PalettePage() {
  var _router$query;
  const router = useRouter();
  const paletteId = useMemo(() => parseInt(router.query.id, 10), [router === null || router === void 0 || (_router$query = router.query) === null || _router$query === void 0 ? void 0 : _router$query.id]);
  const {
    data: {
      palette
    }
  } = usePaletteQuery({
    variables: {
      id: paletteId,
      offset: 0,
      limit: GRID_PAGE_LIMIT
    },
    fetchPolicy: "cache-first"
  });
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(PaletteMetaTags, {
      id: paletteId,
      title: palette.header || palette.name
    }), /*#__PURE__*/_jsx("div", {
      className: styles.container,
      children: /*#__PURE__*/_jsx(PaletteGrid, {
        id: paletteId,
        noContent: /*#__PURE__*/_jsx(NoContentMessage, {
          message: "\u8A72\u5F53\u306E\u4F5C\u54C1\u304C\u3042\u308A\u307E\u305B\u3093"
        })
      })
    })]
  });
}